import React, { useContext, useEffect, useState } from 'react'
import Header2 from '../components/Header2'
import { Container, Form, Table, Pagination } from 'react-bootstrap'
import { RiEyeLine } from "react-icons/ri";
import { IMAGE_URL } from '../API';
import { ProfileContext } from "../context/ProfileContext";
import avtar from "../Assets/Images/image copy 2.png"
import { AiOutlineMail } from "react-icons/ai";
import { LuPhone } from "react-icons/lu";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../components/Loader';

function ConsultationHistory() {
  const navigate = useNavigate();
  const { profile, isLoading, ConsultationHistory, getAllConsultation, totalConsultations } = useContext(ProfileContext);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => { if (currentPage) { getAllConsultation(currentPage, itemsPerPage) } }, [currentPage]);

  const handleNavigateConsultation = (consID) => {
    if (consID) { navigate(`/consultation?consID=${consID}`) }
    else { toast.error('Invalid consultation ID.') }
  }

  return (

    <>
      <style>
        {`
        .comm-table {
          overflow-x: auto;
        }
        @media (max-width: 767px) {
          .comm-table table {
            border: 0;
          }
          .comm-table table thead {
            display: none;
          }
          .comm-table table tr {
            display: block;
            margin-bottom: 1rem;
            border: 1px solid #e0e0e0;
            border-radius: 12px;
            padding: 15px;
            background: #fff;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          }
          .comm-table table td {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #f0f0f0 !important;
            padding: 10px 0 !important;
            text-align: right;
            font-size: 14px;
          }
          .comm-table table td:last-child {
            border-bottom: 0 !important;
          }
          .comm-table table td::before {
            content: attr(data-label);
            float: left;
            font-weight: 600;
            color: #333;
            text-transform: capitalize;
          }
          .id_txt {
            color: #00A1FB !important;
            font-weight: 700 !important;
          }
        }
        .custom-pagination .page-link {
          border-radius: 8px;
          margin: 0 4px;
          border: 1px solid #e0e0e0;
          color: #555;
          font-weight: 500;
          transition: all 0.3s ease;
          padding: 8px 16px;
        }
        .custom-pagination .page-item.active .page-link {
          background: linear-gradient(135deg, #00A1FB 0%, #007bff 100%);
          border-color: transparent;
          color: white;
          box-shadow: 0 4px 10px rgba(0, 161, 251, 0.3);
        }
        .custom-pagination .page-link:hover {
          background-color: #f8f9fa;
          color: #00A1FB;
          border-color: #00A1FB;
        }
        .custom-pagination .page-item.disabled .page-link {
          color: #ccc;
          background-color: #fff;
          border-color: #eee;
        }
        `}
      </style>
      <Loader isLoading={isLoading} />
      <div className="comm_page_outer2">
        <Container>
          <Header2 />
          <div className="comm_profile_head_usr_detail">
            <div className="profile-pic">
              <Form.Control id="file" type="file" name="profile_picture" />
              <figure className="profile-img-edit">
                <img src={profile.image ? `${IMAGE_URL}${profile.image}` : avtar} alt="User" className="img-fluid" />
              </figure>
            </div>
            <div className="name-all">
              <h6>{profile.full_name}</h6>
              <p><AiOutlineMail /> {profile.email}</p>
              <p><LuPhone /> {profile.number}</p>
            </div>
          </div>
          <div className="comm_inner_page_layout">
            <div className="comm_border_box">

              <div className="notifi-list d-flex">
                <div>
                  <h6 className="comm_page_headings">Consultation Histrory</h6>

                  <p className="comm_page_sub_heading">
                    {/* Centralized system for managing patient records, tracking consultation history, treatment plans, and referrals. */}
                  </p>
                </div>

              </div>

              <div className="comm-table pt-0">
                {ConsultationHistory && ConsultationHistory.length > 0 ?
                  <Table responsive="sm">
                    <thead>
                      <tr className="head-class-td">
                        <th>Sr. no.</th>
                        <th>Name</th>
                        <th>Age</th>
                        <th>Gender</th>
                        <th>Condition</th>
                        <th>Status</th>
                        <th width="10%">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ConsultationHistory && ConsultationHistory.length > 0 ?
                        ConsultationHistory.map((data, index) => {
                          return (
                            <tr key={data?._id}>
                              <td className="id_txt" data-label="Sr. no.">{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                              <td data-label="Name">{data?.user_id?.full_name}</td>
                              <td data-label="Age">{data?.age}</td>
                              <td data-label="Gender">{data?.gender}</td>
                              <td data-label="Condition">{data?.condition || 'Not Specified'}</td>
                              <td data-label="Status">{data?.is_completed == 1 ? 'Closed' : 'Open'}</td>
                              <td data-label="Action">
                                <button style={{ border: 'white', background: 'none', cursor: 'pointer' }} onClick={() => handleNavigateConsultation(data?._id)} >
                                  <RiEyeLine size={25} />
                                </button>
                              </td>
                            </tr>
                          )
                        })
                        :
                        <tr><td colSpan={6}>No Consultation History</td></tr>
                      }
                    </tbody>

                  </Table>
                  :
                  <h2 className="text-center mt-5">No consultation history</h2>}
              </div>

              {totalConsultations > itemsPerPage && (
                <div className="d-flex justify-content-center mt-4">
                  <Pagination className="custom-pagination">
                    <Pagination.Prev
                      onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                      disabled={currentPage === 1}
                    />
                    {[...Array(Math.ceil(totalConsultations / itemsPerPage))].map((_, i) => (
                      <Pagination.Item
                        key={i + 1}
                        active={i + 1 === currentPage}
                        onClick={() => setCurrentPage(i + 1)}
                      >
                        {i + 1}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next
                      onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(totalConsultations / itemsPerPage)))}
                      disabled={currentPage === Math.ceil(totalConsultations / itemsPerPage)}
                    />
                  </Pagination>
                </div>
              )}
            </div>
          </div>

        </Container>
      </div>

    </>
  )
}

export default ConsultationHistory